import { Route } from 'react-router-dom';

import { InitialPageLazy } from '../../pages/ui/initial-page/initial-page.lazy';
import { LoadingPageLazy } from '../../pages/ui/loading/loading.lazy';
import { ResultPageLazy } from '../../pages/ui/result/result.lazy';
import { YouBirthdatePageLazy } from '../../pages/ui/your-birthdate/your-birthdate.lazy';
import { YourBirthPlacePageLazy } from '../../pages/ui/your-birthplace/your-birthplace.lazy';
import { YourBirthTimePageLazy } from '../../pages/ui/your-birthtime/your-birthtime.lazy';
import { YourGenderPageLazy } from '../../pages/ui/your-gender/your-gender.lazy';
import { YourNamePageLazy } from '../../pages/ui/your-name/your-name.lazy';

export const Quiz2025Routes = {
  Start: () => '',
  Name: () => 'your_name',
  Birthdate: () => 'birthdate',
  Birthplace: () => 'birthplace',
  Birthtime: () => 'birthtime',
  Gender: () => 'gender',
  Loading: () => 'loading',
  Result: () => 'result',
} as const;

const routes = [
  { path: Quiz2025Routes.Start(), element: <InitialPageLazy /> },
  { path: Quiz2025Routes.Name(), element: <YourNamePageLazy /> },
  { path: Quiz2025Routes.Birthdate(), element: <YouBirthdatePageLazy /> },
  { path: Quiz2025Routes.Birthplace(), element: <YourBirthPlacePageLazy /> },
  { path: Quiz2025Routes.Birthtime(), element: <YourBirthTimePageLazy /> },
  { path: Quiz2025Routes.Gender(), element: <YourGenderPageLazy /> },
  { path: Quiz2025Routes.Loading(), element: <LoadingPageLazy /> },
  { path: Quiz2025Routes.Result(), element: <ResultPageLazy /> },
];

export const quiz2025RouteList = routes.map((route) => (
  <Route key={route.path} path={route.path} element={route.element} />
));
